

const en = {
    // Header
    header: {
        home: 'Home',
        whoWeAre: 'About Us',
        studentsAndGraduates: 'Students & Graduates',
        careerCounseling: 'Career Counseling',
        searchVacancy: 'Browse Jobs',
        login: 'Login',
        register: 'Register',
        profile: 'Profile',
        logout: 'Logout',
    },
    // Homepage
    home: {
        connectNow: 'CONNECT RIGHT NOW!',
        connectSubtitle: 'Join our platform and find the best job opportunities or the talent your company needs.',
        lookingForJob: 'Looking for a Job?',
        lookingForJobDesc: 'Find your ideal job among thousands of available positions',
        searchJobs: 'Search Jobs',
        areYouCompany: 'Are you a Company?',
        areYouCompanyDesc: 'Post your vacancies and find the perfect talent',
        postVacancy: 'Post a Vacancy',
        lastVacancy: 'Recent Vacancies',
        popularCategories: 'Popular Categories',
        categoriesSubtitle: '20+ Vacancy categories waiting for you',
        publishedVacancies: 'Published Vacancies',
        publishedTasks: 'Published Tasks',
        freelancers: 'Freelancers',
        findTheRightSolution: 'Find the Right Solution',
        heroSubtitle: 'The link between PROFESSIONAL/STUDENT – COMPANY, preparing and delivering the professional that today’s company seeks.',
        institutions: 'Institutions',
        institutionsCountLabel: 'Number of allied institutions',
        institutionsAllied: 'Allied institutions',
        users: 'Users',
        students: 'Students',
        graduates: 'Graduates',
        companies: 'Companies',
        companiesCountLabel: 'Number of allied companies',
        companiesAllied: 'Allied companies',
    },
    // About Us
    about: {
        title: 'Who Are We?',
        subtitle: 'Connecting Talent with Opportunities',
        description1: 'The Universidad del Caribe, as a higher education institution, is not only interested in the academic preparation of its students, but also in their professional future. For this reason, UNIEMPLEO was created as a contribution to the labor insertion process of our students and graduates.',
        description2: 'UNIEMPLEO emerges as an initiative of the Universidad del Caribe to provide its students and graduates with an advanced technological platform to support their employment goals and objectives. This way, they can access the job position that best allows them to serve their country.',
        mission: 'Mission',
        missionDesc: 'To introduce to the Dominican employer sector a professional with tomorrow\'s competencies.',
        vision: 'Vision',
        visionDesc: 'A world where professional talent and the employer sector have the necessary empowerment to realize their maximum potential.',
        ctaTitle: 'Boost your professional career!',
        ctaDesc: 'Connect with the best job opportunities in the Dominican employer sector.',
        createAccount: 'Create an Account',
    },
    // Footer
    footer: {
        rights: 'All rights reserved',
        description: 'Job and internship platform of the Universidad del Caribe. Connecting talent with job opportunities.',
        usefulLinks: 'Useful Links',
        privacyPolicy: 'Privacy Policy',
        cookiesPolicy: 'Cookies Policy',
        termsAndConditions: 'Terms and Conditions',
        faq: 'FAQ',
        resources: 'Resources',
        helpDesk: 'Virtual Help Desk',
        blackboard: 'Blackboard',
        mail: 'Mail',
        conecta: 'Conecta',
        consult: 'Consult',
        academicOffer: 'Academic Offer',
        academicCalendar: 'Academic Calendar',
        unicaribeno: 'UNICARIBEÑO Journal',
        academicRequests: 'Academic Requests',
        contact: 'Contact',
        emailContact: 'uniempleo@unicaribe.edu.do',
        phoneContact: '(809) 616-1616 Ext. 705',
        addressContact: '30 de Mayo Highway, Urbanización Tropical. Santo Domingo, Dominican Republic.',
        followUs: 'Follow Us',
        facebook: 'Facebook',
        instagram: 'Instagram',
        linkedin: 'LinkedIn',
    },
    // Students & Graduates
    students: {
        title: 'Students & Graduates',
        subtitle: 'We provide greater opportunities for UNICARIBE students to enter the workforce and put all their knowledge and talents into practice.',
        graduatesDesc1: 'For graduates who want to improve their working conditions, UNIEMPLEO will help them find the desired job position, connecting them with allied companies that value their training and experience.',
        graduatesDesc2: 'For the internship programs that UNICARIBE students must complete, UNIEMPLEO will be the vehicle through which they find their preferred affiliated company and take their first steps in the professional world.',
        graduatesHighlight: 'Whether you are an active student, graduate, professional or entrepreneur, our platform is designed to accompany you at every stage of your professional development.',
        ctaCard: 'Build your professional future',
        ctaCardDesc: 'Choose how you want to register on the platform and take the next step in your professional career.',
        loginAsStudent: 'Login as student/graduate',
        comingSoon: 'Soon you will be able to complete your registration form according to your profile.',
        platformTitle: 'A platform for every stage',
        platformSubtitle: 'UNIEMPLEO connects students, graduates and companies, facilitating job placement, professional growth and high-impact internships.',
        forStudents: 'For Students',
        forStudentsDesc: 'Access to internship opportunities and first jobs to start your professional career with the support of UNICARIBE.',
        forGraduates: 'For Graduates',
        forGraduatesDesc: 'Support to find positions that match your profile, experience and professional growth goals.',
        forInternships: 'Internships & Practices',
        forInternshipsDesc: 'Direct connection with affiliated companies so you can complete your internship programs and gain real experience.',
        ctaTitle: 'Ready to take the next step?',
        ctaDesc: 'Register now and start building your professional future with UNIEMPLEO. Your next opportunity is waiting for you.',
    },
    // Career Counseling
    career: {
        title: 'Career Counseling',
        sectionTitle: 'Career Counseling',
        desc1: 'The Universidad del Caribe, interested in having its students oriented in the changes and perspectives of the labor market, offers counseling from its disciplinary areas.',
        desc2: 'Below you will find the schedule that corresponds to you and the contact information of our specialized advisors.',
        advisors: 'Advisors',
        specializedProfessionals: 'Specialized professionals',
        flexibleHours: 'Flexible Hours',
        flexibleHoursDesc: 'Consult according to your availability',
        specializedGuidance: 'Specialized Guidance',
        specializedGuidanceDesc: 'From all disciplinary areas',
        personalAttention: 'Personalized Attention',
        personalAttentionDesc: 'Direct contact with advisors',
        ourAdvisors: 'Our Advisors',
        ourAdvisorsDesc: 'Meet our team of professionals specialized in career guidance and professional development.',
    },
    // Banner principal
    banner: {
        title1: 'UNIEMPLEO',
        title2: 'The link between',
        title3: 'Student/Professional - Company',
        subtitle: 'Connect your talent with the best job opportunities in today\'s university and business ecosystem.',
        searchJobs: 'Search Jobs',
        joinNow: 'Join Now',
    },
    // Contact
    contact: {
        title: 'Contact',
        subtitle: 'Do you have any questions, suggestions or need help? Contact us!',
        name: 'Name',
        email: 'Email',
        message: 'Message',
        send: 'Send',
    },

    // Job Section
    jobsection: {
        recentVacancies: 'Recent Vacancies',
        browseAllVacancies: 'Browse all vacancies',
        loadingVacancies: 'Loading vacancies...',
        loading: 'Loading...',
        searchTitle: 'Browse Vacancies',
        resultSingular: 'Vacancy found',
        resultPlural: 'Vacancies found',
        sortBy: 'Sort by:',
        sortMostRecent: 'Most recent',
        sortOldest: 'Oldest',
        sortTitleAsc: 'Title (A-Z)',
        sortTitleDesc: 'Title (Z-A)',
        noVacanciesWithFilters: 'No vacancies found with the selected filters.',
        tryAdjustFilters: 'Try adjusting your search criteria.',
        expired: 'Expired',
        previous: 'Previous',
        next: 'Next',
        noDate: 'Date not available',
        salaryFrom: 'From RD$',
        salaryTo: 'Up to RD$',
        errorLoadingSelectors: 'Error loading selectors. Please reload the page.',
        noVacancies: 'No vacancies available.',
        errorLoadingVacancies: 'Error loading vacancies',
        noTitle: 'No title',
        noCity: 'City not specified',
        noCountry: 'Country',
        noContractType: 'Contract Type',
        publishedAgo: 'Published',
        day: 'day',
        hour: 'hour',
        minute: 'minute',
        second: 'second',
        noJobType: 'Job type not specified',
        noSalary: 'Salary not specified',
        // Filters / Sidebar
        filterBy: 'Filter by',
        resetAll: 'Reset all',
        workType: 'Work Type',
        modalidadLabel: 'Work Modality',
        tipoTrabajoLabel: 'Job Type',
        tipoContratoLabel: 'Contract Type',
        allModalities: 'All modalities',
        allTypes: 'All types',
        allContracts: 'All contracts',
        experienceCategory: 'Experience & Category',
        experienceLabel: 'Experience',
        anyExperience: 'Any experience',
        categoryLabel: 'Category',
        allCategories: 'All categories',
        tagsLabel: 'Tags',
        tagsPlaceholder: 'html, css, javascript',
        tagsHelp: 'Tags separated by commas. The vacancy must contain all specified tags.',
        compensation: 'Compensation',
        minSalaryLabel: 'Minimum Salary',
        maxSalaryLabel: 'Maximum Salary',
        location: 'Location',
        countryLabel: 'Country',
        cityLabel: 'City',
        allCountries: 'All countries',
        allCities: 'All cities',
        firstSelectCountry: 'First select a country',
        additionalRequirements: 'Additional Requirements',
        englishRequired: 'English Required',
        searchInputLabel: 'Vacancy title, keywords or phrase',
        searchButton: 'Search',
    },

    // Language switcher
    lang: {
        switchTo: 'Español',
        flag: '🇩🇴',
    },
};

export default en;
